<p id="title" class="headline-small">{{ 'addForms.title' | translate }} </p>
<mat-dialog-content id="content">
  <span class="body-medium">{{ 'addForms.message' | translate }}</span>
  <mat-form-field>
    <mat-label class="body-large">{{ 'addForms.searchForms.label' | translate }}</mat-label>
    <input type="text" class="body-large"
           [placeholder]="'addForms.searchForms.placeholder' | translate"
           aria-label="Search for form"
           matInput
           [formControl]="searchFormsFormControl"
           [matAutocomplete]="auto">
    <mat-icon class="material-icons-outlined" matPrefix>search</mat-icon>
    @if (loadingSearchResult) {
      <mat-spinner id="searchFormsSpinner" diameter="30" matSuffix></mat-spinner>
    }
    <mat-autocomplete class="body-large" autoActiveFirstOption #auto="matAutocomplete"
                      (optionSelected)="selectForm($event.option.value)">
      @for (form of filteredForms | async; track form) {
        <mat-option [value]="form">
          <span>{{ form.title }}</span>
        </mat-option>
      }
      @if ((filteredForms | async)?.length === 0) {
        <mat-option disabled>
          <span class="body-medium">{{ 'addForms.emptyOption.label' | translate }}</span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <div class="flexColumnContainer">
    <span id="selectedFormsTitle" class="title-medium">{{ 'addForms.selectedForms' | translate }}</span>
    @if (chosenForms.length === 0) {
      <span id="noFormsSelected" class="body-medium"
      >{{ 'addForms.noFormsSelected' | translate }}</span>
    }
    @for (form of chosenForms; track form) {
      <div id="selectedFormContainer" class="flexRowContainer">
        <div class="flexColumnContainer">
          <span class="body-large">{{ form.title }}</span>
        </div>
        <button mat-icon-button class="removeButton" (click)="removeForm(form)">
          <mat-icon class="material-symbols-outlined">cancel</mat-icon>
        </button>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ 'addForms.buttons.cancel' | translate }}</button>
  <button id="confirmation" mat-flat-button [disabled]="chosenForms.length === 0 || uploading"
          (click)="addForms()">
    @if (uploading) {
      <mat-spinner diameter="30"></mat-spinner>
    }
    @if (!uploading) {
      <span>
        {{ 'addForms.buttons.addSelectedForms' | translate }}
      </span>
    }
  </button>
</mat-dialog-actions>
